import React, { useState, FC, useEffect } from 'react';
import {
  Box,
  Button,
  TextField,
  InputAdornment,
} from '@mui/material';
import StyledBox from 'views/rebranded-module/tours-module/ToursListingViewV2/components/SubHeaderSection/SubHeaderSection.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import { Typography700 } from 'views/common/components';
import { PricingTermsOverlay } from 'views/rebranded-module/common/components/UI/PricingTermsOverlay';
import { RiSearchLine } from 'react-icons/ri';
import { FILTER_TYPES } from 'views/rebranded-module/tours-module/ToursListingViewV2/utils/constants';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';

const SubHeaderSection:FC<any> = (props) => {
  const {
    subtitle,
    toursCount,
    handleFilterChange,
    updateSearchQueryFilter,
  } = props;
  const cmsData = useContent('ToursListingPage');
  const appNavigator = useAppNavigator();
  const [searchQuery, setSearchQuery] = useState(appNavigator.query.q || '');
  const [openTermsDialog, setOpenTermsDialog] = useState(false);

  const handleSearchQueryChange = (e) => {
    if (!/^\s*$/.test(e.target.value)) {
      updateSearchQueryFilter(e.target.value.trim());
      setSearchQuery(e.target.value);
    } else {
      updateSearchQueryFilter('');
      setSearchQuery('');
    }
  };

  useEffect(() => {
    updateSearchQueryFilter(appNavigator.query.q);
    setSearchQuery(appNavigator.query.q || '');
  }, [appNavigator.query.q]);

  return (
    <StyledBox>

      <Box className="HSSubTitleAndSearchContainer">
        <Typography700 component="h2" variant="body1" className="HSSubTitle">
          <Typography700 component="span" className="HSTouersCount">
            {toursCount}
          </Typography700>
          {subtitle}
        </Typography700>

        <Box className="HSSearchAndTermsContainer">
          <TextField
            data-testid="tours-search"
            placeholder={cmsData.searchTourNameLabel}
            value={searchQuery}
            onChange={(e) => handleSearchQueryChange(e)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleFilterChange((e.target as HTMLInputElement).value.trim(), FILTER_TYPES.SEARCH_VALUE);
              }
            }}
            variant="outlined"
            className="HSSearchInput"
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <RiSearchLine />
                </InputAdornment>
              ),
              inputProps: {
                'data-testid': 'tours-search-input',
              },
            }}
          />
        </Box>
      </Box>

      <Box display="flex" justifyContent="flex-end" width="100%">
        <Button
          variant="text"
          color="secondary"
          className="HSTermsBtn"
          onClick={() => setOpenTermsDialog(true)}
        >
          {cmsData.pricingTermsLabel}
        </Button>
      </Box>

      {/* PricingTerms Dialog  */}
      <PricingTermsOverlay
        open={openTermsDialog}
        onClose={() => setOpenTermsDialog(false)}
      />
    </StyledBox>
  );
};

export { SubHeaderSection };
